/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {Box, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';

type PageContainerProps = {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  stack?: boolean;
  embedded?: boolean;
  compact?: boolean;
};
export const PageContainer: React.FC<PageContainerProps> = ({
  title,
  subtitle,
  children,
  actions,
  stack = true,
  embedded,
  compact,
}) => {
  return (
    <Stack
      spacing={embedded ? 2 : 4}
      sx={{
        marginTop: embedded ? 'calc(-3 * var(--mui-spacing))' : undefined,
        maxWidth: compact ? '680px' : undefined,
        margin: compact ? 'auto' : undefined,
      }}
    >
      <Stack direction={'row'} spacing={3} alignItems={'center'}>
        <Stack sx={{flex: '1 1 auto'}} spacing={0.5}>
          {typeof title === 'string' ? (
            <Typography variant={'h4'} sx={{'&::first-letter': {textTransform: 'capitalize'}}}>
              {title}
            </Typography>
          ) : (
            title
          )}

          {!!subtitle &&
            (typeof subtitle === 'string' ? (
              <Typography color={'text.secondary'} variant={'subtitle2'}>
                {subtitle}
              </Typography>
            ) : (
              subtitle
            ))}
        </Stack>
        {actions && (
          <Stack direction={'row'} gap={2}>
            {actions}
          </Stack>
        )}
      </Stack>
      {stack ? (
        <Stack direction={'column'} spacing={4}>
          {children}
        </Stack>
      ) : (
        <Box>{children}</Box>
      )}
    </Stack>
  );
};
